/* eslint-disable new-cap */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useOutletContext } from 'react-router-dom';
import * as Yup from 'yup';
import { IReport } from '../../../interfaces/Models';
import { reportTypes } from '../../../common/Constants';
import ErrorMessage from '../../../components/ErrorMessage';
import { HMPGeneralValues } from '../../../common/reportsFieldsValues/hmp/HMPGeneralValues';
import HMPGeneralFields from './fields/HMPGeneralFields';
import ReportsForm from '../../../components/Form/ReportsForm';
import SectionDivider from '../../../components/SectionDivider';

const HMPGeneral = () => {
  const { t } = useTranslation();
  const { visitId } = useParams();
  const data: IReport = useOutletContext();

  const initialValues = data
    ? data
    : {
        name: reportTypes.HMP_GENERAL,
        visit: visitId,
        data: HMPGeneralValues,
      };
  const ReportSchema = Yup.object({
    name: Yup.string().required(t('clinic.form.required')),
    visit: Yup.string().required(t('clinic.form.required')),
    data: Yup.object().shape({}),
  });

  const HtmlId = 'HMPGeneral';

  if (data && data.name != reportTypes.HMP_GENERAL) {
    return <ErrorMessage error={t('global.errors.somethingWrong')} />;
  }

  return (
    <ReportsForm
      initialValues={initialValues}
      visitId={visitId || ''}
      validationSchema={ReportSchema}
    >
      <HMPGeneralFields id={HtmlId} />
      <SectionDivider />
    </ReportsForm>
  );
};

export default HMPGeneral;
